<template>
    <div class="page" id="txr">
        <div class="title flex_h_hS_vC">
            <span class="text">延期滞纳管理</span>
            <div class="head-bnt flex_h_hR_vC">
                <div class="export-range flex_h_hC_vC" @click="exportRangeData">
                    <img style="width: 14px;height: 12px;" src="../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png">
                    <span >导出当前范围数据</span>
                </div>
                <div class="export-all flex_h_hC_vC" @click="exportAllData">
                    <img style="width: 14px;height: 12px;" src="../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png">
                    <span >导出全部数据</span>
                </div>
            </div>
        </div>
        <div>
            <div class="select-date flex_h_hL_vC">
                <div class="pick-date">
                    <el-date-picker style=" width: 172px; height: 36px;"
                            v-model="searchForm.billMonth"
                            type="month"
                            value-format="yyyyMM"
                            @change="changeMonth"
                            placeholder="请选择月份">
                    </el-date-picker>
                </div>
                <!--<div class="show-month-scroll flex_h_hL_vC">
                    <vue-scroll :ops="scrollOptionsH()">
                        <div  v-for="(item,index) in months" :key="index" class="srcoll flex_h_hL_vC">
                            <span>{{year}}</span>\
                            <div class="month-radiu" :class="{'actived': showActie(index)}">
                                <span>{{item.month}}</span><span>月</span>
                            </div>
                        </div>
                    </vue-scroll>
                </div>-->
            </div>
            <div class="select-date-separate-line">
            </div>
            <div class="filter-box flex_h_hS_vC">
                <div class="flex_h_hL_vC">
                    <input  v-model="searchForm.orderId" class="filter-input" placeholder="输入订单号">
                   <!-- <el-select v-model="searchForm.status" style="width: 218px;height: 36px" placeholder="选择违约退订类型" size="small">
                        <el-option v-for="item in options"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">

                        </el-option>
                    </el-select>-->
                </div>
                <div class="searchOrReset flex_h_hR_vC">
                    <el-button class="btn-search" @click="search" size="medium" title="搜索"><i class="el-icon-search"> 搜索</i></el-button>
                    <el-button class="btn-reset" @click="reset" size="medium" title="重置"><i class="el-icon-refresh"> 重置</i></el-button>
                </div>
            </div>
        </div>
       <!-- <div class="summary_block boxs flex_v_hL_vC">
            <div class="first_text flex_h_hS_vC">
                <span>退订金额</span>
                <span><small>{{stayCount}}</small>笔</span>
            </div>
            <div class="second_text clamp_1 flex_h ite-fe">
                <span class="bigT">{{money | centsToYuan}}</span> 元
            </div>
        </div>-->
        <div class="table-box">
            <div class="table-box-title flex_h_hL_vC">
                <span class="title">延期滞纳管理列表</span>
            </div>
            <div class="table-box-el">
                <el-table :data="tableData" style="width: 100%;"  :header-cell-style="tableHeaderColor"
                          border fit highlight-current-row tooltip-effect="dark">
                    <el-table-column type="selection" width="28px">
                    </el-table-column>
                    <el-table-column label="订单号" prop="orderId" min-width="17%" header-align="center" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column label="用户" prop="userName"  min-width="17%" header-align="center"
                                     align="center">
                    </el-table-column>
                    <el-table-column label="开户号码" prop="telephone"  min-width="16%" header-align="center" align="center"
                                     show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span style="color: #2DBAA5">
                                  {{scope.row.telephone}}
                          </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="滞纳金（元）" prop="lateAt"  min-width="12%" header-align="center" align="center">
                        <template slot-scope="scope">
                          <span style="color: #FA6241">
                                  {{scope.row.lateAt |centsToYuan}}
                          </span>
                        </template>
                    </el-table-column>
                   <!-- <el-table-column label="清算状态" prop="status"  min-width="12%" header-align="center" align="center"
                                     show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span class="table-row-orange" v-if="scope.row.status !=''">
                                  {{scope.row.status}}
                          </span>
                        </template>
                    </el-table-column>-->
                    <el-table-column label="操作" fixed="right"  width="244px" header-align="center" align="center"
                                     show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="flex_h_hC_vC">
                                <!--<div @click="lookLogData(scope.row.id)">
                                    <img style="width: 10px;height: 10px;" src="../../../../assets/images/recordInformatica/detail.png">
                                    <span class="table-operation-green">查看日志</span>
                                </div>
                                <div  style="margin-left:15px" @click="showClearLogConfirm(scope.row.id)">
                                    <img  style="width: 10px;height: 10px;" src="../../../../assets/images/businessUnsubscribe/liquidation.png">
                                    <span class="table-operation-green">清算</span>
                                </div>
                                <div style="margin-left:15px" @click="showClearLogConfirm(scope.row.id,'enable')" v-if="scope.row.status ==0">
                                    <img style="width: 10px;height: 10px;"  src="../../../../assets/images/businessUnsubscribe/liquidation.png">
                                    <span class="table-operation-green">重新清算</span>
                                </div>-->
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pageBox boxs">
                    <el-pagination @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="searchForm.current"
                                   :page-sizes="[10, 20, 30]"
                                   :page-size="searchForm.size"
                                   layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <baseDialog
            :title="showLogTitle"
            :zIndex="1000"
            :visible.sync="showLogDialog"
            :isFooter="false"
            :modal="modal"
            :close-on-click-modal="false"
            width="688px">
            <div class="show-log-content">
                <vue-scroll :ops="scrollOptionsV()">
                    <div class="show-log-data">
                        <el-timeline>
                            <el-timeline-item
                                    v-for="(activity, index) in logData"
                                    :key="index"
                                    :icon="activity.icon"
                                    :type="activity.type"
                                    :color="activity.color"
                                    :size="activity.size"
                                    :timestamp="activity.date">
                                {{activity.content}}
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                </vue-scroll>
            </div>
        </baseDialog>

        <base-message-box
            :title="confirmTitle"
            :content="confirmContont"
            @cancel="handleCancel()"
            @confirm="handleConfirm()"
            :visible.sync="showConfirm">
        </base-message-box>
    </div>
</template>

<script>
    import {getAllLateMoney,exportLateMoney} from '@/api/Tbs/businessUnsubscribe/deferredManage.js'
    import  baseDialog  from '@/components/Common/BaseDialog/code/baseDialog';
    import  baseMessageBox from  '@/components/Common/BaseConfirmBox/BaseConfirmBox';
    import  {scrollOptionsV,scrollOptionsH} from '@/utils/commonUtils.js'
    import {objectToQueryString} from '@/utils/commonUtils.js';
    export default {
        name: "deferredManage",
        data(){
            return {
                //垂直滚动条
                scrollOptionsV,
                //水平滚动条
                scrollOptionsH,
                searchForm:{
                    billMonth:'',
                    orderId:'',
                    status:'',
                    current:1,
                    size:10,
                },
                options:[{
                          label:'违约',
                           value:"1",
                       },
                    {
                        label: '退订',
                        value: "2",
                    }],
                money: 3400.00,
                stayCount:22,
                total:0,
                tableData:[{
                   orderId: '123244535456',
                    user:'用户',
                    phone:'18826490882',
                    money:'1.00',
                    status:'成功',

                }],
                //弹窗
                modal:false,
                showLogDialog:false,
                showLogTitle:'清算日志',
                showConfirm:false,
                confirmTitle:'清算',
                confirmContont:'确定发起清算？',
                currentMonth:5,
                year:'2020',
                logData:[
                    {
                        date:'2020/09/02 02:02:02',
                        content:'创建违约订单',
                        color:'#FA6241'
                    },
                    {
                        date:'2020/08/12 02:02:02',
                        content:'创建违约订单'
                    },
                    {
                        date:'2020/08/12 02:02:02',
                        content:'创建违约订单'
                    },
                    {
                        date:'2020/08/12 02:02:02',
                        content:'创建违约订单'
                    }
                ],
                months:[
                    {month:'一月'},
                    {month:'二月'},
                    {month:'三月'},
                    {month:'四月'},
                    {month:'五月'},
                    {month:'六月'},
                    {month:'七月'},
                    {month:'八月'},
                    {month:'九月'},
                    {month:'十月'},
                    {month:'十一月'},
                    {month:'十二月'},
                ]
            }
        },
        components: {
            baseDialog,
            baseMessageBox,
        },
        methods:{
            tableHeaderColor({row, column, rowIndex, columnIndex}){
                return 'height:29px;background:rgba(245,245,245,1);border:1px solid rgba(238,238,238,1);opacity:1;'
            },

            changeMonth(value){
              this.searchForm.billMonth = value
            },
            exportRangeData(){
                this.exportLateData(this.searchForm)
            },
            exportAllData(){
              const param = {
                  billMonth:'',
                  orderId:'',
                  status:'',
              }
                this.exportLateData(param)
            },
            search(){
                this.gotoPage(1);
            },
            reset(){
                this.searchForm.billMonth =''
                this.searchForm.status =''
                this.searchForm.orderId =''
            },
            lookLogData(id){
                this.showLogDialog =true
            },

            handleSizeChange(value){
                this.searchForm.size =value
                this.gotoPage(1)
            },
            handleCurrentChange(value){
                this.searchForm.current = value
                this.gotoPage(value)
            },

            showActie(index){
                return  this.currentMonth =index;
            },
            //确认弹窗
            showClearLogConfirm(id){
                this.showConfirm = true
            },
            handleCancel(){
                this.showConfirm =false
            },
            handleConfirm(){
                this.showConfirm =false
            },
            gotoPage(page){
                this.searchForm.current =page;
                getAllLateMoney(this.searchForm).then(res =>{
                    this.tableData = res.data.records;
                    this.total = res.data.total;
                }).catch(error =>{
                    console.log(error)
                })
            },
            //弹窗结束
            //获取年
            getYearMonth(){
                let date = new Date();
                let year = date.getFullYear();
                this.currentMonth = date.getMonth()+1
                this.year =year+'年'
            },

            exportLateData(param){
               /* exportLateMoney(this.params).then(res => {
                    console.log("1111")
                    let blob = new Blob([res], {type: 'application/vnd.ms-excel;charset=utf-8'})
                    let downloadElement = document.createElement('a');
                    let href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = '延期滞纳列表.xlsx';
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); //点击下载
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                })*/
                const url = `${this.$baseNewUrl}esaleb-service-tbs/fdBill/exportLateMoney?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm)}`;
                window.open(url, '_blank');
            }
        },
        mounted() {
            this.getYearMonth()
            this.gotoPage(1)
        }
    }
</script>

<style scoped>
    .title{
        height:44px;
        background:rgba(251,251,251,1);
        opacity:1;
    }
    .title .text{
        margin-left: 12px;
        width:78px;
        height:17px;
        font-size:13px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        line-height:17px;
        color:rgba(43,39,39,1);
        opacity:1;
        text-align: center;
    }
    .title .head-bnt{
        margin-right: 12px;
    }

    .title .head-bnt span{
        margin-left: 5px;
        min-width:78px;
        height:17px;
        font-size:13px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:17px;
        color:rgba(255,255,255,1);
        opacity:1;
    }
    .title .export-range{
        margin-right: 10px;
        width:147px;
        height:30px;
        background:rgba(250,98,65,1);
        opacity:1;
        border-radius:4px;
    }
    .title .export-all{
        width:120px;
        height:30px;
        background:rgba(250,98,65,1);
        opacity:1;
        border-radius:4px;
    }
    .select-date{
        height:124px;
        background:rgba(255,255,255,1);
        opacity:1;
    }
    .pick-date{
        width: 190px;
       margin-left: 12px;
       border-right: 1px solid #F8F8F8;
    }
    .pick-date span{
        width:72px;
        height:17px;
        font-size:13px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:17px;
        color:rgba(57,51,51,1);
        opacity:1;
    }

    .pick-date-line .line{
        margin-left: 27px;
        width: 1px;
        height: 64px;
        background-color: #3B3B3B;
    }
    .show-month-scroll{
        width: 500px;
        margin-left: 40px;
    }
    .show-month-scroll .srcoll{
        margin-right: 60px;
        width: 48px;
    }
    .show-month-scroll .month-radiu {
        width: 48px;
        height: 48px;
        background-color: #FAFAFA;
    }
    .show-month-scroll .month-radiu .actived{
        background-color: #2DBAA5;
    }


    .select-date-separate-line{
        margin-left: 2px;
        margin-right: 2px;
        width: 99%;
        height: 1px;
        background-color: #F8F8F8;
    }
    .filter-box{
        height:60px;
        background:rgba(255,255,255,1);
        opacity:1;
    }
    .filter-box .filter-input{
        margin-left: 12px;
        width:200px;
        height:33px;
        margin-right: 12px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(238,238,238,1);
        opacity:1;
        border-radius:3px;
        padding-left: 10px;
    }
    input::placeholder{
        width:78px;
        height:17px;
        font-size:13px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:17px;
        color:rgba(209,209,209,1);
        opacity:1;
    }
    .summary_block {
        margin-top: 12px;
        width: 207px;
        height: 72px;
        background: #fff;
        box-sizing: border-box;
        padding: 12px 20px;
        font-size: 12px;
        color: #333333;
        white-space: nowrap;
        margin-right: 14px;
    }
    .summary_block .first_text {
        min-width: 160px;
        max-width: 100%;
        margin-bottom: 6px;
    }

     .summary_block .first_text small {
        color: #2DBAA5;
        margin-right: 3px;
    }

    .summary_block .second_text {
        height: 20px;
    }

    .summary_block .second_text span.bigT {
        height: 20px;
        color: #FA6241;
        font-size: 20px;
        font-weight: normal;
        margin-right: 3px;
    }
    .searchOrReset{
        margin-right: 12px;
    }

    #txr .el-button {
        height: 36px;
        width: 80px;
        border-radius: 4px;
        padding: 11px 15px;
        border: none;
    }
    .btn-search {
        background-color: #FA6241;
        color: #fff;
    }
    .btn-search:hover {
        background-color: rgb(247, 143, 120);
    }
    .btn-reset {
        background-color: #F99A1A;
        color: #fff;
    }
    .btn-reset:hover {
        background-color: rgb(248, 186, 105);
    }

    .table-box{
        margin-top: 14px;
    }
    .table-box-title {
        width: 100%;
        height:44px;
        background:rgba(255,255,255,1);
        opacity:1;
    }
    .table-box-title .title{
        margin-left: 12px;
        width:120px;
        height:20px;
        font-size:15px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        line-height:20px;
        color:rgba(43,39,39,1);
        opacity:1;
    }
    .table-row-green{
        width:12px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:16px;
        color:rgba(118,200,25,1);
        opacity:1;
    }
    .table-row-childCount{
        width:7px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:16px;
        color:rgba(45,186,165,1);
        opacity:1;
    }
    .table-row-orange{
        width:36px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:16px;
        color:rgba(250,98,65,1);
        opacity:1;
    }

    .table-operation-green{
        width:24px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:14px;
        color:rgba(45,186,165,1);
        opacity:1;
    }
    /* 分页条 */
    .pageBox {
        width: 100%;
        padding: 15px 0 10px;
        display: flex;
        justify-content: flex-end;
        background: #ffffff;
        border: 1px solid #E4E4E4;
        border-top: none;
    }

    .show-log-content{
          height: 200px;
    }
    .show-log-data{
       margin-left: 13px;
       margin-right: 13px;
    }
    .show-log-data .date{
        min-width:118px;
        height:16px;
        font-size:12px;
        font-family:Microsoft YaHei;
        font-weight:400;
        line-height:24px;
        color:rgba(183,178,175,1);
        opacity:1;
    }
    .show-log-data .content{
        height:68px;

    }
</style>